import PropTypes from "prop-types";
import React, { Component } from "react";
import Header from "./Header";
import MessageList from "./MessageList";
import Bubbles from "./Bubbles";
import UserInput from "./UserInput";
import { LinearProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Launcher from "./Launcher";

// draggable chat
import Draggable, { DraggableCore } from "react-draggable";
// draggable chat END

import { Resizable, ResizableBox } from "react-resizable";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  fetchUserSkillHistory,
  keepScrollPosition,
  updateChatBounds,
  updateChatPosition,
  updateChatSize
} from "../../../../../redux/actions/chatActions";

import _ from "lodash";
import { getChatConfigProp } from "../../../../../common/utils";

const styles = {
  typingMessage: {
    position: "absolute",
    top: "60px",
    left: 0,
    right: 0
  },
  linearProgressChat: {
    borderRadius: 0,
    height: "3px"
  },
  colorPrimary: {
    backgroundColor: "#F78E1E"
  },
  barColorPrimary: {
    backgroundColor: "#fcd1a3" // or fcdab6
  }
};

class ChatWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listeningState: null,

      dragBounds: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      // Resizable Component State
      width: 370,
      height: window.innerHeight < 700 ? window.innerHeight - 100 : 590,
      defaultPosition: {}
    };
  }

  // Resizable Methods
  onResize = (event, { element, size, handle }) => {
    this.setState({ width: size.width, height: size.height });
  };
  // Resizable Methods END

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.playingState === "playing") {
      this.setState({ listeningState: "PLAYING" });
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    // console.log(444);
  }

  onUserInputSubmit(message) {
    this.props.onUserInputSubmit(message);
  }

  onFilesSelected(filesList) {
    this.props.onFilesSelected(filesList);
  }

  onRecordingStateChange(state) {
    this.setState({ listeningState: state });
  }

  // on resize website -> update chat drag area START
  resize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.width !== this.state.width || prevState.height !== this.state.height) {
      // console.log("UPDATING CHAT SIZE");
      this.props.updateChatSize({ width: this.state.width, height: this.state.height });
      this.props.updateChatBounds(this.state.dragBounds);
    }

    if (prevState.defaultPosition !== this.state.defaultPosition) {
      // console.log("UPDATING CHAT POSITION");
      this.props.updateChatPosition(this.state.defaultPosition);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }
  // on resize website -> update chat drag area END

  // on open sidebar -> move chat in updated drag area
  onControlledDrag = (e, position) => {
    const { x, y } = position;
    this.setState({ controlledPosition: { x, y } });
  };

  renderDraggableComponent = () => {
    return this.props.chatPosition ? (
      <Draggable
        handle=".dragBtn" // drag the chat by dragging this element
        cancel=".sc-header--close-button" // element doesn't drag when dragging this element, which is in .dragBtn
        onStop={(e, data) => {
          this.setState({ defaultPosition: { x: data.x, y: data.y } });
        }}
        defaultPosition={{ x: this.props.chatPosition.x, y: this.props.chatPosition.y }}
        bounds={{
          left: this.state.dragBounds.left,
          top: this.state.dragBounds.top,
          right: this.state.dragBounds.right,
          bottom: this.state.dragBounds.bottom
        }}
      />
    ) : (
      <Draggable
        handle=".dragBtn" // drag the chat by dragging this element
        cancel=".sc-header--close-button" // element doesn't drag when dragging this element, which is in .dragBtn
        onStop={(e, data) => {
          this.setState({ defaultPosition: { x: data.x, y: data.y } });
        }}
        bounds={{
          left: this.state.dragBounds.left,
          top: this.state.dragBounds.top,
          right: this.state.dragBounds.right,
          bottom: this.state.dragBounds.bottom
        }}
      />
    );
  };

  render() {
    const { classes } = this.props;
    let messageList = this.props.messageList || [];
    let classList = ["sc-chat-window", this.props.isOpen ? "opened" : "closed"];
    const sidebarIsOpen = this.props.sidebarIsOpen; // to determine chat drag range
    const chatResizeDragContainerReset = this.props.assistantPage
      ? { transform: "none" }
      : { transform: "translate(-654px, 19px)" };

    // on mobile there is no <Draggable/> wrapper because it block full screen chat on mobile
    const isDesktop = window.innerWidth > 450;

    const chatHTML = (
      <div className={classList.join(" ")}>
        {this.props.assistantPage ? (
          <div></div>
        ) : (
          <Header
            teamName={this.props.agentProfile.teamName}
            imageUrl={this.props.agentProfile.imageUrl}
            onClose={this.props.onClose}
            listeningState={this.state.listeningState}
            // botIsTyping={this.props.botIsTyping}
          />
        )}
        <MessageList
          source={this.props.source}
          messages={messageList}
          imageUrl={this.props.agentProfile.imageUrl}
          // botIsTyping={this.props.botIsTyping}
          userImage={this.props.userImage}
          userFullName={this.props.userFullName}
          removeDialogElicit={this.props.removeDialogElicit}
        />
        <div className={classes.typingMessage}>
          {this.props.botIsTyping ? (
            <LinearProgress
              classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
              className={classes.linearProgressChat}
            />
          ) : (
            ""
          )}
        </div>
        <Bubbles
          bubbles={this.props.bubbles}
          isBubbleDrillDown={this.props.isBubbleDrillDown}
          bubblesOnMessageWasSent={this.props.bubblesOnMessageWasSent}
          bubbleDrillDown={this.props.bubbleDrillDown}
          bubblesTopLevel={this.props.bubblesTopLevel}
          bubbleAnswer={this.props.bubbleAnswer}
        />
        <UserInput
          onSubmit={this.onUserInputSubmit.bind(this)}
          onFilesSelected={this.onFilesSelected.bind(this)}
          showEmoji={this.props.showEmoji}
          playingState={this.props.playingState}
          onRecordingStateChange={this.onRecordingStateChange.bind(this)}
          listeningState={this.state.listeningState}
        />
      </div>
    );

    const dragBounds = this.state.dragBounds;
    const innerWidth = document.body.scrollWidth;

    // 370 width of .chat-drag-container, 20 margins left and right,  270 sidebar + 1 border
    dragBounds.left = sidebarIsOpen ? -innerWidth + 661 : -innerWidth + 390;
    // 590 height of .chat-drag-container, 80 height of top navbar, 20 margins top and bottom
    dragBounds.top = -window.innerHeight + 690;
    dragBounds.bottom = -this.state.height + 590;
    dragBounds.right = -this.state.width + 370;

    let width = _.get(this.props, "chatSize.width", this.state.width);
    let height = _.get(this.props, "chatSize.height", this.state.height);
    let chatBounds = this.state.dragBounds;
    if (this.props.chatBounds) {
      chatBounds = this.props.chatBounds;
    }
    // checks if user is on the "Assistant page" and shows the correct css class
    const classesName = this.props.assistantPage
      ? "assistant-page-chat-window"
      : `resize-and-drag-container container-is-opened`;

    return (
      <div
        // className="resize-and-drag-container"
        // className={`resize-and-drag-container ${this.props.isOpen ? "container-is-opened" : ""}`}
        className={classesName}
        //style={chatResizeDragContainerReset}
      >
        {isDesktop && !this.props.assistantPage ? (
          this.props.chatPosition ? (
            <Draggable
              handle=".dragBtn" // drag the chat by dragging this element
              cancel=".sc-header--close-button" // element doesn't drag when dragging this element, which is in .dragBtn
              onStop={(e, data) => {
                this.setState({ defaultPosition: { x: data.x, y: data.y } });
              }}
              defaultPosition={{ x: this.props.chatPosition.x, y: this.props.chatPosition.y }}
              bounds={chatBounds}
            >
              <div className={`chat-drag-container no-cursor`} style={{ transform: "none" }}>
                <ResizableBox
                  className={`box ${this.props.isOpen ? "resizableChatIsOpened" : "resizableChatIsClosed"}`}
                  height={height}
                  width={width}
                  onResize={this.onResize}
                  resizeHandles={["n", "e", "se", "s"]}
                  minConstraints={[280, 350]}
                >
                  <div className="box" style={{ width: width + "px", height: height + "px" }}>
                    {chatHTML}
                  </div>
                </ResizableBox>
              </div>
            </Draggable>
          ) : (
            <Draggable
              handle=".dragBtn" // drag the chat by dragging this element
              cancel=".sc-header--close-button" // element doesn't drag when dragging this element, which is in .dragBtn
              onStop={(e, data) => {
                this.setState({ defaultPosition: { x: data.x, y: data.y } });
              }}
              bounds={{
                left: this.state.dragBounds.left,
                top: this.state.dragBounds.top,
                right: this.state.dragBounds.right,
                bottom: this.state.dragBounds.bottom
              }}
            >
              <div className="chat-drag-container no-cursor" style={{ display: this.props.isOpen ? "unset" : "none" }}>
                <ResizableBox
                  className={`box ${this.props.isOpen ? "resizableChatIsOpened" : "resizableChatIsClosed"}`}
                  height={height}
                  width={width}
                  onResize={this.onResize}
                  resizeHandles={["n", "e", "se", "s"]}
                  minConstraints={[280, 350]}
                >
                  <div className="box" style={{ width: width + "px", height: height + "px" }}>
                    {chatHTML}
                  </div>
                </ResizableBox>
              </div>
            </Draggable>
          )
        ) : (
          chatHTML
        )}
      </div>
    );
  }
}

ChatWindow.propTypes = {
  agentProfile: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func,
  onUserInputSubmit: PropTypes.func.isRequired,
  showEmoji: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    chat: state.chat,
    chatPosition: getChatConfigProp(state, "chatPosition"),
    chatSize: getChatConfigProp(state, "chatSize"),
    chatBounds: getChatConfigProp(state, "chatBounds")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        updateChatSize,
        updateChatPosition,
        updateChatBounds
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ChatWindow));

export { ChatWindow };
